<template>
  <img src="http://yunlei-rabbit-hn2.oss-cn-heyuan.aliyuncs.com/2025/4/8/1909585864974467074.png" alt="" />
  <div class="box" style="margin-top: 0px">
    <!-- 可以使用 CellGroup 作为容器 -->
    <van-cell-group inset style="height: 42px" class="container">
      <van-field v-model="value" label="姓名" placeholder="请输入您的真实姓名 " />
    </van-cell-group>
    <van-cell-group inset style="height: 42px" class="container">
      <van-field v-model="value1" label="手机" placeholder="请输入您的联系方式 " type="digit" />
    </van-cell-group>
    <van-cell-group inset style="height: 42px" class="container">
      <van-field v-model="value2" label="微信号" placeholder="请输入您的微信号" />
    </van-cell-group>
    <van-cell-group inset style="height: 42px" class="container">
      <van-field v-model="value3" label="发展区域" placeholder="请输入您的发展区域 " />
    </van-cell-group>
    <van-cell-group inset style="height: 42px" class="container">
      <van-field v-model="value4" label="当前职业" placeholder="请输入您的当前职业 " />
    </van-cell-group>
  </div>
  <div class="button" @click="join">
    <van-button type="primary" color="white" block round>
      <text style="color: skyblue; font-weight: bold; font-size: 20px">提交</text>
    </van-button>
  </div>
</template>

<script>
import { ref } from "vue";
import { Toast, Dialog } from "vant";
import { req } from "@/axios/http";

export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  setup() {
    const value = ref("");
    const value1 = ref("");
    const value2 = ref("");
    const value3 = ref("");
    const value4 = ref("");
    const show = ref(false);
    return {
      value,
      value1,
      value2,
      value3,
      value4,
      show,
    };
  },
  methods: {
    join() {
      var num = /^(13[0-9]|14[5|7]|15[0|1|2|3|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\d{8}$/;
      if (this.value == "") Toast("输入的真实姓名不能为空!!");
      else if (this.value1 == "") Toast("输入的联系方式不能为空!!");
      else if (this.value1.length != 11) Toast("输入正确的电话号码!!");
      else if (!num.test(this.value1)) Toast("输入正确的电话号码!!");
      else if (this.value2 == "") Toast("输入的微信号不能为空!!");
      else if (this.value3 == "") Toast("输入的发展区域不能为空!!");
      else if (this.value4 == "") Toast("输入的当前职业不能为空!!");
      else
        req
          .post({
            url: "/app/rabbit/common/applyjoin/add",
            data: {
              name: this.value,
              phone: this.value1,
              wechatId: this.value2,
              developArea: this.value3,
              currentOccupation: this.value4,
            },
          })
          .then((res) => {
            console.log(res);
            Dialog.alert({
              title: "申请成功",
              message: "24小时内会有客服和您联系，请保持通讯通畅",
              theme: "round-button",
              confirmButtonColor: "#00c4ff",
            }).then(() => {
              this.value = "";
              this.value1 = "";
              this.value2 = "";
              this.value3 = "";
              this.value4 = "";
            });
          });
    },
  },
  created() {
    document.title = "合伙人招募";
  },
};
</script>

<style>
#app {
  height: 100%;
  background-color: #fca028;
}

img {
  width: 100%;
}

.container {
  margin: 25px 15px;
}

label {
  font-weight: bold;
  color: black;
  font-size: 35px;
}

.button {
  width: 80%;
  margin: 40px auto;
}
</style>
